import store from "../store/index";
//--------------------
// get combatant slots
//---------------------
export default async function getCombatantSlots(combatant_slug) {
  //
  return new Promise((resolve, reject) => {
    //--------------
    // access store
    //--------------
    const this_store = store;
    //--------------
    // set endpoint
    //--------------
    let endpoint = "api/v1/combatants/" + combatant_slug + "/slots/";
    //--------------------
    // set api call parms
    //--------------------
    let request = {
      method: "GET",
      endpoint: endpoint,
    };
    //--------------------------------
    // call combatant slots api (get)
    //--------------------------------
    this_store.dispatch("combat/viewCombatantSlots", request)
    .then((slots) => {
      let data = slots.data.results[0]
      resolve(data);
    })
    .catch((err) => {
      reject(err);
    });
  });
}
